import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import { useContext } from 'react';
import { LocationContext, navigate } from "./internal";

var Link = function Link(_ref) {
  var to = _ref.to,
      rest = _objectWithoutProperties(_ref, ["to"]);

  return React.createElement("a", _extends({
    href: to
  }, rest, {
    onClick: function onClick(event) {
      event.preventDefault();
      navigate(to);
    }
  }));
};

var NavLink = function NavLink(_ref2) {
  var to = _ref2.to,
      className = _ref2.className,
      activeClassName = _ref2.activeClassName,
      rest = _objectWithoutProperties(_ref2, ["to", "className", "activeClassName"]);

  var context = useContext(LocationContext);
  var theClassName = to === context.pathname ? activeClassName : className;
  return React.createElement("a", _extends({
    href: to,
    className: theClassName
  }, rest, {
    onClick: function onClick(event) {
      event.preventDefault();
      navigate(to);
    }
  }));
};

export { Link, NavLink };